import { render, staticRenderFns } from "./ListProjectMobile.vue?vue&type=template&id=5a56c3de&scoped=true&"
import script from "./ListProjectMobile.vue?vue&type=script&lang=js&"
export * from "./ListProjectMobile.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a56c3de",
  null
  
)

export default component.exports